import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function MotDePasseOublie() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Renseignez votre email.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setDone(true);
      toast.success(data.message || "Demande envoyée.");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] px-6 py-20">
      <div className="mx-auto max-w-md">
        <Link to="/" className="inline-block">
          <Logo className="h-20" />
        </Link>
        <h1 className="mt-12 text-4xl font-extrabold tracking-tighter">Mot de passe oublié</h1>
        <p className="mt-3 text-neutral-500">
          Entrez l’email de votre compte : nous vous enverrons un lien pour choisir un nouveau mot de passe.
        </p>
        {done ? (
          <div data-testid="forgot-done" className="mt-10 rounded-2xl border border-emerald-200 bg-emerald-50 p-6 text-sm text-emerald-800">
            <p className="font-semibold">Si un compte existe pour cet email, un lien de réinitialisation vient d’être envoyé.</p>
            <p className="mt-2">Pensez à vérifier vos spams. Le lien est valable 1 heure.</p>
            <Link to="/connexion" className="mt-4 inline-block font-semibold text-brand underline underline-offset-4">
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 space-y-4">
            <input
              data-testid="forgot-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="w-full rounded-lg border border-neutral-300 bg-white px-4 py-3 outline-none focus:border-brand transition-colors"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-btn"
              className="w-full rounded-full bg-brand px-6 py-4 font-bold text-white transition-colors hover:bg-brand-hover disabled:opacity-60"
            >
              {loading ? "Envoi…" : "Envoyer le lien de réinitialisation"}
            </button>
            <p className="text-center text-sm text-neutral-500">
              <Link to="/connexion" className="font-semibold text-brand underline underline-offset-4">
                Retour à la connexion
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
